module.exports = __webpack_public_path__ + "main/assets/public/social-icons/twitter.453b4545841fb432.svg";